(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kbbc-site-header"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.kbbcStickyHeaderBound) return;

    window.kbbcStickyHeaderBound = true;

    let previousScrollPosition = Math.max(window.scrollY, 0);
    let frameRequested = false;
    let observedHeaderSection = null;

    const syncHeaderHeight = (section) => {
      document.documentElement.style.setProperty(
        '--kbbc-sticky-header-height',
        `${Math.ceil(section.getBoundingClientRect().height)}px`
      );
    };

    const headerResizeObserver =
      'ResizeObserver' in window
        ? new ResizeObserver(() => {
            if (observedHeaderSection) syncHeaderHeight(observedHeaderSection);
          })
        : null;

    const observeHeaderSection = (section) => {
      if (observedHeaderSection === section) return;
      if (observedHeaderSection) headerResizeObserver?.unobserve(observedHeaderSection);
      observedHeaderSection = section;
      headerResizeObserver?.observe(section);
      syncHeaderHeight(section);
    };

    const updateHeader = () => {
      const header = document.querySelector('[data-kbbc-site-header]');
      const section = header?.closest('.kbbc-site-header-section');

      if (!header || !section) {
        frameRequested = false;
        return;
      }

      observeHeaderSection(section);

      const behavior = header.dataset.stickyBehavior || 'none';
      const scrollPosition = Math.max(window.scrollY, 0);

      if (behavior === 'none') {
        section.classList.remove('is-scrolled', 'is-sticky-hidden');
        previousScrollPosition = scrollPosition;
        frameRequested = false;
        return;
      }

      if (scrollPosition <= 8) {
        section.classList.remove('is-scrolled', 'is-sticky-hidden');
      } else {
        if (scrollPosition >= 48) section.classList.add('is-scrolled');

        if (behavior === 'scroll_up') {
          const scrollDifference = scrollPosition - previousScrollPosition;
          const headerHasFocus = header.contains(document.activeElement);

          if (scrollDifference > 5 && scrollPosition > 160 && !headerHasFocus) {
            section.classList.add('is-sticky-hidden');
          } else if (scrollDifference < 0) {
            section.classList.remove('is-sticky-hidden');
          }
        } else {
          section.classList.remove('is-sticky-hidden');
        }
      }

      previousScrollPosition = scrollPosition;
      frameRequested = false;
    };

    const requestHeaderUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateHeader);
    };

    window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
    window.addEventListener('resize', requestHeaderUpdate);
    document.addEventListener('shopify:section:load', requestHeaderUpdate);
    updateHeader();
  })();

  (() => {
    if (window.kbbcMobileMenuBound) return;

    window.kbbcMobileMenuBound = true;

    const closeMobileMenu = () => {
      document.querySelectorAll('[data-kbbc-mobile-menu][open]').forEach((menu) => {
        menu.querySelectorAll('details[open]').forEach((submenu) => submenu.removeAttribute('open'));
        menu.removeAttribute('open');
      });
    };

    const mobileViewport = window.matchMedia('(max-width: 749px)');
    const handleViewportChange = (event) => {
      if (!event.matches) closeMobileMenu();
    };

    document.addEventListener('click', (event) => {
      const openMenu = document.querySelector('[data-kbbc-mobile-menu][open]');
      if (!openMenu) return;
      if (event.target.closest?.('[data-kbbc-mobile-menu] a')) closeMobileMenu();
      if (!openMenu.contains(event.target)) closeMobileMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = document.querySelector('[data-kbbc-mobile-menu][open]');
      if (!openMenu) return;
      const toggle = openMenu.querySelector('summary');
      closeMobileMenu();
      toggle?.focus();
    });

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', handleViewportChange);
    } else {
      mobileViewport.addListener(handleViewportChange);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
